import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

interface AppUpdateToastProps {
  isVisible: boolean;
  isForceUpdate: boolean;
}

export const AppUpdateToast = ({ isVisible, isForceUpdate }: AppUpdateToastProps) => {
  useEffect(() => {
    if (isVisible) {
      const message = isForceUpdate 
        ? 'Critical update detected! Updating now...'
        : 'New version available! Updating...';

      toast(message, {
        icon: <Loader2 className="h-4 w-4 animate-spin" />,
        duration: isForceUpdate ? 1000 : 3000,
        position: 'top-center',
      });
    }
  }, [isVisible, isForceUpdate]);

  return null;
};